import gqlClient from '../client/gqlClient';
import gql from 'graphql-tag';
import checkBrandUserSession from '../../brand_session';

export const queryEditRequest = async (contentId, isSelectAll) => {
    try {
        if(!window.Cypress) await checkBrandUserSession();
        if (gqlClient.client === undefined) {
            await gqlClient.createClient();
        }
        if (gqlClient.client === undefined) {
            throw new Error('Unable to create client');
        }
        const result = await gqlClient.client.query({
            query : gql`
                query editRequest($input: getEditRequestInput!) {
                    editRequest(input: $input) {
                        editRequests {
                            id
                            contentId
                            userId
                            message
                            emailAddress
                            createdAt
                        }
                        internalMessages {
                            id
                            contentId
                            userId
                            message
                            emailAddress
                            createdAt
                        }
                    }
                }
            `,
            fetchPolicy: 'no-cache',
            variables: {input: {contentId: contentId, ...(isSelectAll && {isSelectAll: true})}}
        });
        if (result.data.editRequest) {
            return result.data.editRequest;
        }
    } catch (error) {
        throw error;
    }
    return [];
}


// WEBPACK FOOTER //
// ./graphql/queries/queryEditRequest.js